/* eslint no-template-curly-in-string: 0 */
import { ERROR_TYPES, HTTP_REQUEST_TYPES } from "../../../utils/enums";

const timeoutImg = require("../../../assets/images/timeout.png");

const errors = {
  uiErrors: {
    [ERROR_TYPES.UI_ERRORS.UNCAUGHT_EXCEPTION]: {
      title: "Error del Sistema",
      description: "Hemos detectado un error del sistema que impide el procesamiento de su pago en este momento; por favor, inténtelo de nuevo más tarde."
    },
    [ERROR_TYPES.UI_ERRORS.MALFORMED_PAYWALL_URL]: {
      title: "Acceso No Permitido",
      description: "Debe acceder a este sitio utilizando el enlace único enviado a su correo electrónico."
    },
    [ERROR_TYPES.UI_ERRORS.CANCELLED_PAYMENT]: {
      title: "Pago Cancelado",
      description: "Este pago se ha cancelado y ya no es válido para su uso."
    },
    [ERROR_TYPES.UI_ERRORS.EXPIRED_PAYMENT]: {
      title: "Pago Vencido",
      description: "La fecha límite para aceptar este pago ha vencido."
    },
    [ERROR_TYPES.UI_ERRORS.ARCHIVED_PAYMENT]: {
      title: "Pago Archivado",
      description: "Este pago ya no está activo y no se puede acceder a él ni ser modificado."
    },
    [ERROR_TYPES.UI_ERRORS.FAILED_PAYMENT]: {
      title: "Pago Fallido",
      description: "Se produjo un error al procesar su pago. Intente su solicitud nuevamente o seleccione una red de pago diferente."
    },
    [ERROR_TYPES.UI_ERRORS.OAUTH_DECLINED]: {
      title: "Usuario Cancelado",
      description:
        "Con el fin de procesar su pago por medio de ${paymentNetwork.displayName}, primero debe iniciar sesión en su cuenta para confirmar su identidad. Por favor, inicie sesión con ${paymentNetwork.displayName} o elija una red de pagos diferente."
    },
  },
  byHttpRequestTypeAndResponseStatus: {
    [HTTP_REQUEST_TYPES.DEFAULT]: {
      default: {
        props: {
          title: "¡Uy!",
          description: "Ocurrió un problema. Por favor, inténtelo de nuevo en otro momento.",
        }
      },
      300: {
        props: {
          title: "¿Necesita más Tiempo?",
          description: "Por su seguridad, el tiempo para el proceso de selección del pago vence tras 10 minutos. Por favor, inténtelo de nuevo."
        }
      },
      400: {
        props: {
          title: "¡Uy!",
          description: "Ocurrió un problema. Por favor, inténtelo de nuevo en otro momento.",
        }
      },
      500: {
        props: {
          title: "¡Uy!",
          description: "Ocurrió un problema. Por favor, inténtelo de nuevo en otro momento.",
        }
      }
    },
    [HTTP_REQUEST_TYPES.VALIDATION_ATTEMPTS]: {
      default: {
        props: {
          title: "Página Web Bloqueada",
          description: [
            {
              type: "div",
              string:
                "No podemos acceder a su información de pago. Si continúa recibiendo este error, por favor, pruebe alguna de las siguientes opciones: ",
            },
            {
              type: "div",
              string:
                "<ul><li>Acceda al pago desde una red WiFi o local diferente.</li><li>Desconecte su conexión WiFi actual y utilice el servicio de su celular.</li><li>Use un dispositivo diferente para acceder a su pago.</li><li>Abra la URL del pago en un navegador diferente.</li></ul>",
              props: {
                style: {
                  padding: "1em 0 0 3em"
                }
              }
            }
          ]
        }
      },
      400: {
        props: {
          title: "Error de Autorización",
          description: "Por favor, verifique su dirección URL para asegurarse de que coincida con la enviada a su correo electrónico."
        }
      },
    },
    [HTTP_REQUEST_TYPES.FETCH_PROGRAM_CONFIGURATION]: {
      default: {
        props: {
          title: "Error de Configuración",
          description: "Se produjo un error al acceder a la configuración de su programa. Por favor, inténtelo de nuevo."
        }
      },
      300: {
        props: {
          title: "¿Necesito más tiempo?",
          description: "Por su seguridad, el tiempo para el proceso de selección del pago vence tras 10 minutos. Por favor, inténtelo de nuevo."
        }
      }
    },
    [HTTP_REQUEST_TYPES.FETCH_PAYMENT_ACCOUNTS]: {
      default: {
        props: {
          title: "Error de Cuentas",
          description: "Se produjo un error al acceder a la información de la cuenta de su programa. Por favor, inténtelo de nuevo."
        }
      },
      300: {
        props: {
          title: "¿Necesito más tiempo?",
          description: "Por su seguridad, el tiempo para el proceso de selección del pago vence tras 10 minutos. Por favor, inténtelo de nuevo."
        }
      }
    },
    [HTTP_REQUEST_TYPES.FETCH_PAYMENT]: {
      default: {
        props: {
          title: "Error de Pago",
          description: "No pudimos acceder a su pago. Por favor, inténtelo de nuevo."
        }
      },
      300: {
        props: {
          title: "¿Necesito más tiempo?",
          description: "Para su seguridad, el proceso de selección de pagos finaliza después de 10 minutos. Por favor intente su solicitud nuevamente."
        }
      }
    },
    [HTTP_REQUEST_TYPES.RECIPIENT_LOGIN]: {
      default: {
        props: {
          title: "Error en el Inicio de Sesión del Destinatario",
          description: "Hubo un problema al tratar de iniciar su sesión. Por favor, inténtelo de nuevo."
        }
      },
      300: {
        props: {
          title: "¿Necesito más tiempo?",
          description: "Para su seguridad, el proceso de selección de pagos finaliza después de 10 minutos. Por favor intente su solicitud nuevamente."
        }
      }
    },
    [HTTP_REQUEST_TYPES.ACCEPT_PAYMENT]: {
      default: {
        props: {
          title: "Error al Aceptar el Pago",
          description: "Hubo un problema al tratar de aceptar su pago. Por favor, inténtelo de nuevo."
        }
      },
      300: {
        props: {
          title: "¿Necesito más tiempo?",
          description: "Para su seguridad, el proceso de selección de pagos finaliza después de 10 minutos. Por favor intente su solicitud nuevamente."
        }
      }
    },
    [HTTP_REQUEST_TYPES.CURRENCY_CONVERSIONS]: {
      default: {
        props: {
          title: "Currency Conversion Failed",
          description: "We were unable to process the conversion for the selected currency. Please try your request again."
        }
      },
      401: {
        props: {
          title: "Need more time?",
          description: "For your security, the payment selection process times out after 10 minutes. Please try your request again."
        }
      },
    }
  },
  default: {
    default: {
      title: "Error de Pago",
      description: "Nuestro sistema no puede procesar su pago en este momento; por favor, inténtelo de nuevo más tarde."
    },
    500: {
      title: "¡Uy!",
      description: "Tenemos un problema. Ya estamos revisando esta situación."
    }
  },
  acceptPaymentTimeout: {
    default: {
      img: timeoutImg,
      title: "¿Necesito más tiempo?",
      description: "Para su seguridad, el proceso de selección de pagos finaliza después de 10 minutos. Por favor intente su solicitud nuevamente."
    }
  },
  oauthError: {
    userDeclined: {
      title: "Cancelado por el Usuario",
      description: "Con el fin de procesar su pago por medio de ${paymentNetwork.displayName}, primero debe iniciar sesión en su cuenta para confirmar su identidad. Por favor, inicie sesión con ${paymentNetwork.displayName} o elija una red de pagos diferente."
    },
    default: {
      title: "Error Desconocido",
      description: "Se produjo un error al intentar iniciar sesión con ${paymentNetwork.displayName}. Si continúa recibiendo este error, por favor, elija una red de pagos distinta."
    }
  },
  oauthDeclined: {
    title: "Cancelado por el Usuario",
    description: "Con el fin de procesar su pago por medio de ${paymentNetwork.displayName}, primero debe iniciar sesión en su cuenta para confirmar su identidad. Por favor, inicie sesión con ${paymentNetwork.displayName} o elija una red de pagos diferente."
  },
  suspectedFirewall: {
    title: "Página Web Bloqueada",
    description: [
      {
        type: "p",
        string:
          "No podemos acceder a su información de pago. Si continúa recibiendo este error, por favor, pruebe alguna de las siguientes opciones: ",
        props: {
          style: {
            padding: "1em"
          }
        }
      },
      {
        type: "p",
        string:
          "<ul><li>Acceda al pago desde una red WiFi o local diferente.</li><li>Desconecte su conexión WiFi actual y utilice el servicio de su celular.</li><li>Use un dispositivo diferente para acceder a su pago.</li><li>Abra la URL del pago en un navegador diferente.</li></ul>",
        props: {
          style: {
            padding: "1em 2em 1em 3em"
          }
        }
      }
    ]
  }
};

export default errors;
